import {useEffect, useReducer, useState } from "react";
import { trimNumber, trimString } from "Utils/utilityFunctions";
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',
    SET_INITIAL_DATA: 'set-data',
    SET_INITIAL_CHECK_DATA: 'set-check-data',

    ADD_QUESTION: 'add-question',
    ADD_ANSWER: 'add-answer',

    UPDATE_QUESTION: 'update-question',
    UPDATE_ANSWER: 'update-answer',

    CLEAR_QUESTION_ANSWERS: 'clear-question-answers',
    
    RADIO_CHANGE: 'radio-change',
    RADIO_SET_ERRORS: 'radio-set-errors',
    RADIO_REMOVE_ERRORS: 'radio-remove-errors',

    CHECK_CHANGE: 'check-change',
    CHECK_SET_ERRORS: 'check-set-errors',
    CHECK_REMOVE_ERRORS: 'check-remove-errors',

};


const trimValue = (value, maxLength, maxValue, typeCode) => {
    if(typeCode=="NUMBER"){
        return trimNumber(value, maxLength, maxValue);
    }
    else if(typeCode=="TEXT"){
        return trimString(value, maxLength);
    }
    else if(typeCode=="NUMBER_NP"){
        return trimString(value, maxLength);
    }
    else{
        return value;
    }
}

function noneConditions(state, action, def){
    var questionSection = state.questions[action.subSection];
    var path = questionSection[action.questionCode/* + "_" + action.questionId*/];

    var uncheck = [];

    if(action.questionCode === 'pso32'){
        if(action.answerCode!="C192" && action.checked==true){
            uncheck.push("C192");
        }
    }

    return path.answers.map((answer) => {
        //console.log(answer);
        //console.log(action);
        if(action.questionCode=="prov11"){
            //console.log("CODE11");
            //console.log(path);
        }
        
                            /*isInvalid: "isInvalid" in action ? action.isInvalid : path.isInvalid,
                            errors: "errors" in action ? action.errors : path.errors,
                            isValid: "isValid" in action ? action.isValid : path.isValid*/

        if (answer.answerCode == action.answerCode) {
           //console.log(action.answerCode);
            //console.log(action);
            if("value" in action){
                //console.log(path.typeCode + " --- " + action.questionCode);
                if(path.typeCode=="NUMBER"){
                    answer.value=trimNumber(action.value,answer.maxLength, answer.maxValue);
                }
                else if(path.typeCode=="TEXT"){
                    answer.value=trimString(action.value,answer.maxLength);
                }
                else if(path.typeCode=="CHECKBOX_NUMBER"){
                    //console.log(action.value);
                    if(action.answerCode=="C199" || action.answerCode =="C012"){
                        if((action.value).hasOwnProperty("number")){
                            //console.log("number");
                            answer.value.number=trimNumber(action.value.number,6, 999999);
                        }
                        else{
                            answer.value.number="";
                        }
                        if((action.value).hasOwnProperty("text")){
                            //console.log("text");
                            answer.value.text=trimString(action.value.text,answer.maxLength);
                        }
                        else{
                            answer.value.text="";
                        }
                        
                        //console.log(action.value);
                        //console.log(action.value.number);
                        //console.log(action.value.text);

                        
                        if((action.value.number=="" || action.value.number==null) && (action.value.text=="" || action.value.text==null)){
                            //console.log("CLEARED");
                            answer.checked=false;
                            answer.value.number="";
                            answer.value.text="";
                        }
                        else {
                            answer.checked=true;
                        }
                    }
                    else{
                        //answer.value = action.value;

                        if(action.value=="" || action.value==null){
                            answer.checked=false;
                        }
                        else {
                            answer.value=action.value;
                            answer.checked=true;
                        }
                    }
                    
                        
                }
                //else if(path.typeCode=="CHECKBOX" || path.typeCode=="RADIO"){
                    //answer.value = action.value;

                    //answer.checked = action.checked;
                //}
                else{
                    answer.value=action.value;
                }

                if(path.typeCode=="CHECKBOX" || path.typeCode=="RADIO"){
                    //answer.value = action.value;

                    if(action.value=="" || action.value==null){
                        answer.checked=false;
                    }
                    else {
                        answer.checked=true;
                    }
                }

                
            }
            if("visible" in action){
                answer.visible=action.visible;
            }
            if("disabled" in action){
                answer.disabled=action.disabled;
            }
            if("isInvalid" in action){
                answer.isInvalid=action.isInvalid;
            }
            if("errors" in action){
                answer.errors=action.errors;
            }
            if("isValid" in action){
                answer.isValid=action.isValid;
            }
            

            if(action.questionCode=="prov11"){
                
                //console.log("checked" in action);
                //console.log(action);
            }

            if("checked" in action){
                //console.log(path.typeCode + " --- " + action.questionCode);
                if(path.typeCode=="CHECKBOX" || path.typeCode=="RADIO" || path.typeCode=="CHECKBOX_NUMBER"){
                    //console.log(path.typeCode + " --- " + action.questionCode + "----" + action.checked);
                    //console.log(action.checked);
                    answer.checked = action.checked;

                    if(action.checked==false){
                        
                        if(path.typeCode=="CHECKBOX_NUMBER" && (action.answerCode=="C199" || action.answerCode =="C012")){
                            answer.value.text = "";
                            answer.value.number = "";
                        }
                        else{
                            answer.value="";
                        }
                    }
                    else{
                        
                    }

                    //console.log(path.typeCode + " --- " + action.questionCode + "----" + action.checked + " -- " + answer.checked);
                    //console.log(answer.checked);
                }
            }
        }
        else {
            if(path.typeCode=="RADIO" && action.checked==true){
                answer.checked=false;
            }
            if(path.typeCode=="CHECKBOX"){

                if(action.questionCode === 'pso32'){
                    if(action.answerCode==="C192" && action.checked==true){
                        answer.checked=false;
                    }
                    else{
                        if(uncheck.includes(answer.answerCode)){
                            answer.checked=false;
                        }
                    }
                }
            }
        }
        
        return answer;
        
    })


  /*  if(action.questionCode === 'pso32'){
        if(action.answerCode==="C192" && action.checked==true){
            return answer.checked = action.checked;
        }
        else if(action.answerCode!="C192" && action.checked==true){
            return false;
        }
        else {
            return def;
        }
    }
    else {
        return def;
    }*/
    
}

function clearAnswers(state, action, def){
    var questionSection = state.questions[action.subSection];
    var path = questionSection[action.questionCode];
    ////console.log(questionSection);
    ////console.log(path);

    //var uncheck = [];

    //if(action.questionCode === 'pso32'){
       // if(action.answerCode!="C192" && action.checked==true){
        //    uncheck.push("C192");
        //}
    //}

    return path.answers.map((answer) => {
        ////console.log(answer);

        if (answer.answerCode == "C012" || answer.answerCode == "C199") {
            //console.log("change");
            //console.log(answer);
            
            if(path.typeCode=="CHECKBOX_NUMBER"){
                answer.checked=false;
                answer.value.text="";
                answer.value.number="";
            }
            else{
                answer.value="";
                answer.checked=false;
            }
        }
        else{
            if(path.typeCode=="RADIO"){
                answer.checked=false;
            }
            else if(path.typeCode=="CHECKBOX"){
                answer.checked=false;
            }
            else if(path.typeCode=="CHECKBOX_NUMBER"){
                answer.checked=false;
                answer.value="";
            }
            else if(path.typeCode=="NUMBER"){
                answer.value="";
            }
        }
        
        
        return answer;
        
    })

    
}

const SectionDataReducer = (state, action) => {
    ////console.log("dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                sectionName: action.sectionName,
                sectionLength: action.sectionLength,
                questions: {

                   /*[action.questionCode]: {
                        id: action.questionId,
                        orderNumber: action.questionOrderNo,
                        questionCode: action.questionCode,
                        reportYear: action.questionReportYear,
                        
                        questionDisplayNo: action.questionDispNo,
                        description: action.questionDesc,
                        subText: action.questionSubText,
                        
                        typeCode: action.questionType,
                        topicCode: action.questionTopicCode,

                        adminOnly: action.adminOnly,
                        required: action.questionRequired,

                        maxLength: action.questionMaxLength,
                        maxValue: action.questionMaxValue,
                        answers: [
                            /*{
                                id: 760,
                                answerCode: "C027",
                                description: "Association; includes medical society and any other type of professional association or trade association",
                                maxLength: 0,
                                reportYear: 2023,
                                maxValue: null
                            }*/
                        /*]
                    }*/
                }
            };
        }

        case ACTIONS.ADD_QUESTION: {
            var questionSection = state.questions[action.subSection];

            //console.log(action);

            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.subSection]:{
                        ...questionSection,
                        [action.questionCode.toLowerCase()/* + "_" + action.questionId*/]: {
                            id: action.questionId,
                            orderNumber: action.questionOrderNo,
                            questionCode: action.questionCode.toLowerCase(),
                            reportYear: action.questionReportYear,
                            
                            questionDisplayNo: action.questionDispNo,
                            description: action.questionDesc,
                            subText: action.questionSubText,
                            
                            typeCode: action.questionType,
                            topicCode: action.questionTopicCode,
    
                            adminOnly: action.adminOnly,
                            required: action.questionRequired,
    
                            maxLength: action.questionMaxLength,
                            maxValue: action.questionMaxValue,
                            answers: [
                                
                            ],
                            value: action.value,
                            checked: action.checked,
                            visible: action.visible,
                            disabled: action.disabled,

                            isInvalid: false,
                            errors: [],
                            isValid: false
                        }
                    }
                 }
            };
        }

        case ACTIONS.UPDATE_QUESTION: {
            //console.log(action);
            //console.log(state);
            var questionSection = state.questions[action.subSection];
            var path = questionSection[action.questionCode.toLowerCase()/* + "_" + action.questionId*/];
            //console.log(questionSection);
            //console.log(path);
            ////console.log(action.questionCode.toLowerCase()/* + "_" + action.questionId*/);
            ////console.log(path.visible);

            var clearA = false;

            if(action.pageType!="VIEW"){
                if("visible" in action){
                    if(action.visible==false){
                        clearA=true;
                    }
                }
                /*else{
                    if(path.visible==false){
                        clearA=true;
                    }
                }*/
            }
            

            //console.log(action);
            if(path!=null){
                if(action.pageType!="VIEW"){
                    return {
                        ...state,
                        questions: {
                            ...state.questions,
                            [action.subSection]:{
                                ...questionSection,
                                [action.questionCode.toLowerCase()/* + "_" + action.questionId*/]: {
                                    ...path,
                                    value: "value" in action ? trimValue(action.value, path.maxLength, path.maxValue, path.typeCode) : path.value,
                                    visible: "visible" in action ? action.visible : path.visible,
                                    checked: "checked" in action ? action.checked : path.checked,
                                    disabled: "disabled" in action ? action.disabled : path.disabled,
                                    isInvalid: "isInvalid" in action ? action.isInvalid : path.isInvalid,
                                    errors: "errors" in action ? action.errors : path.errors,
                                    isValid: "isValid" in action ? action.isValid : path.isValid,
                                    answers: clearA == true ? clearAnswers(state, action, path.answers): path.answers
                                }
                            }
                        }
                    };
                }
                else{
                    return {
                        ...state,
                        questions: {
                            ...state.questions,
                            [action.subSection]:{
                                ...questionSection,
                                [action.questionCode.toLowerCase()/* + "_" + action.questionId*/]: {
                                    ...path,
                                    value: "value" in action ? action.value/*trimValue(action.value, path.maxLength, path.maxValue, path.typeCode)*/ : path.value,
                                    visible: "visible" in action ? action.visible : path.visible,
                                    checked: "checked" in action ? action.checked : path.checked,
                                    disabled: "disabled" in action ? action.disabled : path.disabled,
                                    isInvalid: "isInvalid" in action ? action.isInvalid : path.isInvalid,
                                    errors: "errors" in action ? action.errors : path.errors,
                                    isValid: "isValid" in action ? action.isValid : path.isValid,
                                    answers: path.answers//clearA == true ? clearAnswers(state, action, path.answers): path.answers
                                }
                            }
                        }
                    };
                }
                
            }
            else{
                return {
                    ...state
                };
            }
            
        }

        

        case ACTIONS.CLEAR_QUESTION_ANSWERS: {
            var questionSection = state.questions[action.subSection];
            var path = questionSection[action.questionCode.toLowerCase()];
            //console.log(action);
            //console.log("CLEARANSWER" + questionSection);
            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.subSection]:{
                        ...questionSection,
                        [action.questionCode.toLowerCase()/* + "_" + action.questionId*/]: {
                            ...path,
                            answers: clearAnswers(state, action, path.answers)
                        }          
                    }           
                }          
            }


            var questionSection = state.questions[action.subSection];
            var path = questionSection[action.questionCode];
            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.subSection]:{
                        ...questionSection,
                        [action.questionCode]: {
                            ...path,
                            value: '',
                            answers:
                                //...path.answers, 
                                path.answers.map((ans) => {
                                    //console.log(ans);
                                    ans.checked = false;
                                    ans.value='';
            
                                    //console.log(ans);
                                    return ans;
                                })//,
                                //action.newAnswer
                            
                        }
                    }
                 }
            };
        }

        case ACTIONS.ADD_ANSWER: {
            //console.log(action);
            
            var questionSection = state.questions[action.subSection];
            ////console.log(questionSection);
            ////console.log(action.questionCode);
            ////console.log(action.questionCode.toLowerCase() + "_" + action.questionId);
            var path = questionSection[action.questionCode.toLowerCase()/* + "_" + action.questionId*/];
            ////console.log(path);
            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.subSection]:{
                        ...questionSection,
                        [action.questionCode.toLowerCase()/* + "_" + action.questionId*/]: {
                            ...path,
                            answers:[...path.answers, action.newAnswer]
                            /*id: action.id,
                            answerCode: action.answerCode,
                            description: action.description,
                            maxLength: action.maxLength,
                            reportYear: action.reportYear,
                            maxValue: action.maxValue*/
                        }
                    }
                        
                 }
            };
        }


        case ACTIONS.UPDATE_ANSWER: {
            //console.log(action);
            var questionSection = state.questions[action.subSection];
            var path = questionSection[action.questionCode.toLowerCase()/* + "_" + action.questionId*/];
            //console.log(questionSection);
            //console.log(path);
            ////console.log(action.questionCode.toLowerCase() + "_" + action.questionId);
            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.subSection]:{
                        ...questionSection,
                        [action.questionCode.toLowerCase()/* + "_" + action.questionId*/]: {
                            ...path,
                            answers: noneConditions(state, action, path.answers)
                        }
                                    
                    }
                                
                                
                                
                }
                            
            }

        }
        
        case ACTIONS.RADIO_CHANGE: {
            ////console.log("state-RADIO_CHANGE");
            ////console.log(state);

            //const path = state.data[action.name];
            ////console.log(path.radioButtons);
           // //console.log(action.name);

            /*
            type: 'radio',
                name: "roleId",
                value: 10000,
                validation: {
                    required: true,
                    isInvalid: false, //REPLACE
                    errors: []
                },
                //disabled: getVarValue(disabled),
                //readOnly: getVarValue(readOnly),
                //hideFieldOrgTypes: hideFieldOrgTypes,
                InputRef: useRef(null)
            */
            return {
                ...state,
                value: action.value,
                validation: {
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }
        
        case ACTIONS.CHECK_CHANGE: {
            ////console.log("state");
            ////console.log(state);

            //const path = state.data[action.name];
            ////console.log(path.checkBoxes);
           // //console.log(action);

            return {
                ...state,
                [action.name]: action.checked
            };
        }


        case ACTIONS.RADIO_SET_ERRORS: {
           // //console.log("state");
           // //console.log(state);

            //const path = state.data[action.name];
            ////console.log(path.radioButtons);
            ////console.log(action.name);

            /*
            type: 'radio',
                name: "roleId",
                value: 10000,
                validation: {
                    required: true,
                    isInvalid: false, //REPLACE
                    errors: []
                },
                //disabled: getVarValue(disabled),
                //readOnly: getVarValue(readOnly),
                //hideFieldOrgTypes: hideFieldOrgTypes,
                InputRef: useRef(null)
            */
            return {
                ...state,
                //value: action.value
                validation: {
                    ...state.validation,
                    isInvalid: true,
                    errors: action.errors
                }
            };
            /*//console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }

                    }
                }
            };*/
        }
        case ACTIONS.RADIO_REMOVE_ERRORS: {
            ////console.log("state");
            ////console.log(state);

            const path = state.data[action.name];
            ////console.log(path.radioButtons);
            ////console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }

                    }
                }
            };
        }
        
       

        case ACTIONS.CHECK_SET_ERRORS: {
            ////console.log("state");
            ////console.log(state);

            const path = state.data[action.name];
            ////console.log(path.checkBoxes);
            ////console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }

                    }
                }
            };
        }
        case ACTIONS.CHECK_REMOVE_ERRORS: {
           // //console.log("state");
            ////console.log(state);

            const path = state.data[action.name];
           // //console.log(path.checkBoxes);
            ////console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }

                    }
                }
            };
        }
    }
}







export {ACTIONS, SectionDataReducer};